import { Action, Dispatch } from "redux";
import { ActionTypes } from "./actionTypes";
import {
    AppError,
    ErrorCode,
    IApplicationState,
    IUserEndPoint, IGetUserEndPoint,ISAPOrder,IBusinessUser
} from "../../models/applicationState";
import { UserDefinedService } from "../../services/userDefinedEndPointService";

import { createAction, createPayloadAction, IPayloadAction } from "./actionCreators";
import { appInfo } from "../../common/appInfo";

export default interface IUserDefinedActions {
    loadEndPoints(endPoint: IGetUserEndPoint): Promise<IUserEndPoint[]>;
    createEndPoint(endPoint: IUserEndPoint, body): Promise<IUserEndPoint>;
    deleteEndPoint(endPoint: IGetUserEndPoint): Promise<string>;
    enableDisableEndPoint(endPoint: IGetUserEndPoint): Promise<string>;
    createSAPOrder(endPoint: ISAPOrder, body): Promise<ISAPOrder>;
    getListofBusinessUsers(): Promise<IBusinessUser[]>;
    getBusinessUserDetailsbyId(useroid:string): Promise<IBusinessUser>;
}

/**
 * Dispatches Load Project action and resolves with IProject
 * @param project - Project to load
 */
export function loadEndPoints(endPoint: IGetUserEndPoint):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<IUserEndPoint[]> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const appState = getState();
        const endPointService = new UserDefinedService();
        const endPoints = endPointService.loadEndPoints(endPoint);
        // dispatch(loadAllModels(loadedModels));
        return endPoints;
    };
}
/**
 * Enable Disable userEndPoint
 */
export function enableDisableEndPoint(endPoint: IGetUserEndPoint):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<string> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const appState = getState();
        const endPointService = new UserDefinedService();
        const endPoints = endPointService.enableDisableEndPoint(endPoint);
        // dispatch(loadAllModels(loadedModels));
        return endPoints;
    };
}

/**
 * Delete userEndPoint
 */
export function  deleteEndPoint(endPoint: IGetUserEndPoint):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<string> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const appState = getState();
        const endPointService = new UserDefinedService();
        const endPoints = endPointService.deleteEndPoint(endPoint);
        // dispatch(loadAllModels(loadedModels));
        return endPoints;
    };
}

/**
 * Enable Disable userEndPoint
 */
export function createEndPoint(endPoint: IUserEndPoint, body):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<IUserEndPoint> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const appState = getState();
        const endPointService = new UserDefinedService();
        const endPoints = endPointService.createUserEndPoint(endPoint, body);
        // dispatch(loadAllModels(loadedModels));
        return endPoints;
    };
}
 
export function createSAPOrder(endPoint: ISAPOrder, body):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<ISAPOrder> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const appState = getState();
        const endPointService = new UserDefinedService();
        const endPoints = endPointService.createSAPOrder(endPoint, body);
        // dispatch(loadAllModels(loadedModels));
        return endPoints;
    };
}



export function getListofBusinessUsers():
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<IBusinessUser[]> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
       // const appState = getState();
        const endPointService = new UserDefinedService();
        const businessUsers = endPointService.loadListofBusinessUsers();
        // dispatch(loadAllModels(loadedModels));
        return businessUsers;
    };
}


export function getBusinessUserDetailsbyId(useroid:string):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<IBusinessUser> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
       // const appState = getState();
        const endPointService = new UserDefinedService();
        const businessUsers = endPointService.getBusinessUserDetailsbyId(useroid);
        // dispatch(loadAllModels(loadedModels));
        return businessUsers;
    };
}
  

